import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ISearchResponse, ISearchResponseRow, QueryResultTypes } from "./quick-search.models";

@Injectable({
    providedIn: "root"
})
export class QuickSearchService {
    private readonly apiClient = inject(ApiClientService);

    private readonly sortOrder: Map<string, number>;

    search(term: string): Observable<ISearchResponseRow[]> {
        if (term[0] === ">") {
            return this.getModaler(term);
        } else if (term.length >= 3) {
            return this.apiClient.get<ISearchResponse>(`search?query=${term}`)
                .pipe(map(x => this.mapSearchResponse(x)));
        }
        return of([]);
    }

    extendedSearch(term: string): Observable<ISearchResponseRow[]> {
        if (term.length >= 3) {
            return this.apiClient.get<ISearchResponse>(`search/ExtendedSearch?query=${term}`)
                .pipe(map(x => this.mapSearchResponse(x)));
        }
        return of([]);
    }

    getModaler(term: string): Observable<ISearchResponseRow[]> {
        const searchTerm = term.replace(">", "").trim().toLowerCase();
        const modaler = this.getModalerJson().filter(m => m.title.toLowerCase().indexOf(searchTerm) > -1);
        if (modaler.length > 0) {
            return of(modaler);
        }

        return of([]);
    }

    private getModalerJson(): ISearchResponseRow[] {
        return [
            {
                title: "Mina maskinlag",
                type: QueryResultTypes.Modal

            },
            {
                title: "Mina produktionsmallar",
                type: QueryResultTypes.Modal

            },
            {
                title: "Mina förkalkylsmallar",
                type: QueryResultTypes.Modal

            }
        ];
    }

    private mapSearchResponse(response: ISearchResponse): ISearchResponseRow[] {
        return response.results.map(x => x.rows).reduce((a, b) => a.concat(b), []);
    }
}
